// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2895": "fa85db70","522": "6f55264f","5545": "976c794a",}[chunkId] + ".css"
}